import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { GoalsCardIllustrationDark } from '../assets/GoalsCardIllustrationDark';

import { GoalsCardIllustrationLight } from '../assets/GoalsCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const GoalsOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <GoalsCardIllustrationLight />,
		componentDark: <GoalsCardIllustrationDark />,
	};
	return (
		<CarouselBaseCard
			messages={{ ...goalsMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const goalsMessages = defineMessages({
	heading: {
		defaultMessage: 'Track progress with goals',
		description: 'Heading for the Goals onboarding card',
		id: 'townsquare.twc-onboarding-widget.goals-card.heading',
	},
	description: {
		defaultMessage: 'Align your work with goals to make sure you are on track.',
		description: 'Description for the Goals onboarding card',
		id: 'townsquare.twc-onboarding-widget.goals-card.description',
	},
	cta: {
		defaultMessage: 'Try Goals',
		description: 'Call to action text for the Goals onboarding card',
		id: 'townsquare.twc-onboarding-widget.goals-card.cta',
	},
});
